export default {
  pageCatalogShopId: null
};
